module.exports = __webpack_public_path__ + "img/defa-square.jpg";